import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import { maybe } from "@saleor/misc";
import { StoreOrderDetails_storeOrder } from "@saleor/storeOrders/types/StoreOrderDetails";
import { OrderVerticalType } from "@saleor/types/globalTypes";
import moment from "moment-timezone";
import React from "react";
import { FormattedMessage } from "react-intl";

import StoreOrderDeliveryType from "../StoreOrderDeliveryType";
import Cutlery from "./components/Cutlery";

const useStyles = makeStyles(
  theme => ({
    cancelButton: {
      "& span": {
        color: "#E26139"
      },
      border: "1px solid #E26139"
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    },
    textBold: {
      fontSize: "14px",
      fontWeight: 600,
      whiteSpace: "nowrap"
    },
    textRight: {
      fontSize: "14px",
      textAlign: "right",
      whiteSpace: "nowrap"
    }
  }),
  { name: "StoreOrderInfo" }
);

export interface StoreOrderInfoProps {
  storeOrder: StoreOrderDetails_storeOrder;
}

const StoreOrderInfo: React.FC<StoreOrderInfoProps> = props => {
  const { storeOrder } = props;

  const classes = useStyles(props);

  const checkVerticalType = verticalType => {
    if (verticalType === "GENERAL_MERCHANDISE") {
      return "General Merchandise";
    } else if (verticalType === "FOOD_AND_BEVERAGES") {
      return "Food and Beverages";
    } else if (verticalType === "GROCERY") {
      return "Grocery";
    } else {
      return "";
    }
  };

  return (
    <CardContent>
      <table className={classes.root}>
        <tbody>
          <tr>
            <td className={classes.textBold}>
              <FormattedMessage
                defaultMessage="Delivery Type"
                description="order total"
              />
            </td>
            <td className={classes.textRight}>
              {maybe(() => storeOrder.order.shippingMethod.deliveryType) ? (
                <StoreOrderDeliveryType
                  delType={storeOrder.order.shippingMethod.deliveryType}
                />
              ) : (
                " "
              )}
            </td>
          </tr>
          <tr>
            <td className={classes.textBold}>
              <FormattedMessage
                defaultMessage="Classification"
                description="order total"
              />
            </td>
            <td className={classes.textRight}>
              {maybe(() => storeOrder.order.verticalType) ? (
                <span>
                  {checkVerticalType(
                    maybe(() => storeOrder.order.verticalType)
                  )}
                </span>
              ) : (
                " "
              )}
            </td>
          </tr>
          <tr>
            <td className={classes.textBold}>
              <FormattedMessage
                defaultMessage="Order Type"
                description="order detail type"
              />
            </td>
            <td className={classes.textRight}>
              {storeOrder && storeOrder.order && storeOrder.order.isMultiTenant
                ? "Multi-tenant"
                : "Single-tenant"}
            </td>
          </tr>
          <tr>
            <td className={classes.textBold}>
              <FormattedMessage
                defaultMessage="Order Date"
                description="order detail date"
              />
            </td>
            <td className={classes.textRight}>
              {storeOrder &&
                storeOrder.order &&
                moment(storeOrder.order.created).format("lll")}
            </td>
          </tr>
          <tr>
            <td className={classes.textBold}>
              <FormattedMessage
                defaultMessage="Delivery Schedule"
                description="order detail delivery schedule"
              />
            </td>
            <td className={classes.textRight}>
              {storeOrder &&
              storeOrder.order &&
              storeOrder.order.shippingSchedule
                ? moment(storeOrder.order.shippingSchedule).format("ll")
                : "-"}
            </td>
          </tr>
          {storeOrder?.order.verticalType ===
          OrderVerticalType.FOOD_AND_BEVERAGES ? (
            <tr>
              <td colSpan={2}>
                <Cutlery
                  hasCutlery={maybe(() => storeOrder.order.hasCutlery)}
                />
              </td>
            </tr>
          ) : null}
          {/*  */}
          <tr>
            <td className={classes.textBold}>
              <FormattedMessage
                defaultMessage="Picked up Photo"
                description="order detail picked up photo"
              />
            </td>
            <td className={classes.textRight}>
              {storeOrder && storeOrder.parcelImageUrl !== "" ? (
                <a
                  href={storeOrder.parcelImageUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View
                </a>
              ) : (
                "Not Available"
              )}
            </td>
          </tr>
          <tr>
            <td className={classes.textBold}>
              <FormattedMessage
                defaultMessage="Receipt Photo"
                description="order detail receipt photo"
              />
            </td>
            <td className={classes.textRight}>
              {storeOrder && storeOrder.receiptImageUrl !== "" ? (
                <a
                  href={storeOrder.receiptImageUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View
                </a>
              ) : (
                "Not Available"
              )}
            </td>
          </tr>
          {/*  */}
          {/* <tr>
            <td className={classes.textBold}>
              <FormattedMessage
                defaultMessage="Home Location"
                description="home location"
              />
            </td>
            <td className={classes.textRight}>
              {maybe(() => storeOrder?.order?.dropOffLocation?.name, "N/A")}
            </td>
          </tr> */}
        </tbody>
      </table>
    </CardContent>
  );
};
StoreOrderInfo.displayName = "StoreOrderInfo";
export default StoreOrderInfo;
